import React, { Fragment, useEffect, useState } from "react";
import {
  AddIcon,
  DeleteIcon,
  DownArrowIcon,
  UpArrowIcon,
} from "../../../assets/icons";
import CannedTestSection from "../../../model/cannedTests/cannedTestSection";
import Select from "react-select";
import { getCalculators } from "../../../api/subject.service";
import Loader from "../../shared/loader/loader";
import { connect } from "react-redux";
import CannedTestSectionGroup from "../../../model/cannedTests/cannedTestSectionGroup";
import CannedTestSectionGroupQuestion from "../../../model/cannedTests/cannedTestSectionGroupQuestion";
import SectionGroupCard from "./sectionGroupCard";
import { deleteCannedTestSectionGroup } from "../../../api/cannedTests.service";
import { toast } from "react-toastify";
interface SectionCardProps {
  index: number;
  profile: any;
  saveSection: (data: any, index: number) => void;
  editQuestionHandler: (questionId: number) => void;
  section: CannedTestSection;
  onDeleteSectionClick: (index: number) => void;
  cannedTestTypeId?: number;
}

const SectionCard = (props: SectionCardProps) => {
  const defaultPageNumber = 1;
  const defaultPageSize = 10;
  const [loading, setLoading] = useState(false);
  const [showSaveOrderFlag, setShowSaveOrderFlag] = useState(false);
  const [section, setSection] = useState<CannedTestSection>(props.section);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isEditIndex, setIsEditIndex] = useState<number>(-1);
  const [sectionGroups, setSectionGroups] = useState<CannedTestSectionGroup[]>(
    props.section.sectionGroups
  );
  const [toggleCard, setToggleCard] = useState<boolean>(true);
  const [calculatorOptions, setCalculatorOptions] = useState<
    Array<{ value: number; label: string }>
  >([]);

  useEffect(() => {
    props.saveSection(section, props.index);
  }, [section]);

  useEffect(() => {
    const loadCalculators = async () => {
      try {
        const res = await getCalculators();
        const data = res.data || [];
        const opts = data.map((c: any) => ({
          value:
            c.calculatorTypeId ??
            c.calculatorTypeId ??
            c.CalculatorTypeId ??
            c.id,
          label: c.name,
        }));
        setCalculatorOptions(opts);
      } catch (error) {
        console.error(error);
      }
    };
    // Only load if this feature applies (types 3 or 4)
    if (props.cannedTestTypeId === 3 || props.cannedTestTypeId === 4) {
      loadCalculators();
    }
  }, [props.cannedTestTypeId]);

  const onEditClick = (question, index) => {
    setIsEdit(true);
    setIsEditIndex(index);
    setTimeout(() => {
      for (const key in question) {
        const element: any = document.getElementById(`${key}`);
        if (element) element.value = question[key];
      }
    });
  };

  const onDeleteGroupQuestionClick = (groupIndex, index) => {
    let groupQuestions = sectionGroups[groupIndex].sectionGroupQuestions.filter(
      (q, i) => i !== index
    );
    groupQuestions = groupQuestions.map((item, index) => {
      item.sort = index + 1;
      return item;
    });
    const grp = [...sectionGroups];
    grp[groupIndex].sectionGroupQuestions = groupQuestions;
    setSectionGroups(grp);
  };

  const onDeleteGroupClick = (groupIndex) => {
    const groups = sectionGroups.filter((q, i) => i !== groupIndex);

    deleteCannedTestSectionGroup(
      sectionGroups[groupIndex].cannedTestSectionGroupId
    ).then((r) => {
      toast.success("Section Group deleted successfully");
      setSectionGroups(groups);
    });
  };

  const handleDragEnd = (event, groupIndex) => {
    const { newItems } = event;

    if (!newItems || newItems.length <= 1) return;

    const updatedItems = newItems.map((item, index) => ({
      ...item,
      sort: index + 1,
    }));

    sectionGroups[groupIndex].sectionGroupQuestions = updatedItems;
    setSection({ ...section, sectionGroups: sectionGroups });
    setShowSaveOrderFlag(true);
  };

  const onAddGroupClick = () => {
    const defaultSectionGroup: CannedTestSectionGroup = {
      cannedTestSectionGroupId: 0,
      cannedTestSectionId: 0,
      type: "",
      instructions: "",
      sort: (sectionGroups?.length ?? 0) + 1,
      sectionGroupQuestions: [],
    };
    const groups = [...sectionGroups];
    groups.push(defaultSectionGroup);
    setSectionGroups(groups);
  };

  const onAddGroupQuestionClick = (groupIndex) => {
    const currentGroupQuestions =
      sectionGroups[groupIndex].sectionGroupQuestions;
    const orderNumber =
      currentGroupQuestions[currentGroupQuestions.length - 1]?.sort ?? 0;
    const newQuestionRow: CannedTestSectionGroupQuestion = {
      questionId: 0,
      sort: 0,
      cannedTestSectionGroupId: 0,
    };
    newQuestionRow.sort = orderNumber + 1;

    currentGroupQuestions.push(newQuestionRow);
    sectionGroups[groupIndex].sectionGroupQuestions = currentGroupQuestions;
    setSectionGroups(sectionGroups);
    setIsEdit(true);
    setIsEditIndex(currentGroupQuestions.length - 1);
  };

  const onQuestionChange = (e, index, groupIndex) => {
    sectionGroups[groupIndex].sectionGroupQuestions[index].questionId =
      e.target.value;
    setSection({ ...section, sectionGroups: sectionGroups });
  };

  const onSectionGroupTypeChange = (e, groupIndex) => {
    sectionGroups[groupIndex].type = e.target.value;
    setSection({ ...section, sectionGroups: sectionGroups });
  };

  const onSectionGroupInstructionChange = (e, groupIndex) => {
    sectionGroups[groupIndex].instructions = e.target.value;
    setSection({ ...section, sectionGroups: sectionGroups });
  };

  const onSectionSubjectChange = (e) => {
    setSection({ ...section, subject: e.target.value });
  };

  const onSectionTitleChange = (e) => {
    setSection({ ...section, title: e.target.value });
  };

  const onSectionSubTitleChange = (e) => {
    setSection({ ...section, subtitle: e.target.value });
  };

  const onSectionCalculatorChange = (opt: any) => {
    const calculatorTypeId = opt ? opt.value : undefined;
    setSection({ ...section, calculatorTypeId });
  };

  const onQuestionSubmit = () => {
    setIsEdit(false);
    setIsEditIndex(-1);
  };

  return (
    <Fragment>
      <div className="mt-6 cursor-pointer bg-gray-50 border rounded-lg">
        {loading && <Loader></Loader>}
        <div className="p-4">
          <div className="mb-2 flex items-center justify-between">
            <div className="flex justify-start items-center">
              {!toggleCard && (
                <DownArrowIcon
                  className="h-5 w-5 ml-1 text-gray-500"
                  onClick={() => {
                    setToggleCard(!toggleCard);
                  }}
                />
              )}
              {toggleCard && (
                <UpArrowIcon
                  className="h-5 w-5 ml-1 text-gray-500"
                  onClick={() => {
                    setToggleCard(!toggleCard);
                  }}
                />
              )}
              <h3 className="ml-2">
                {section.subject}{" "}
                {section.title.length > 0 ? " - " + section.title : ""}{" "}
              </h3>
            </div>
            <div className="flex justify-end items-center">
              <button
                type="button"
                onClick={() => {
                  props.onDeleteSectionClick(props.index);
                }}
                className="flex my-4 mx-3  items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
              >
                <DeleteIcon className="w-3 h-3"></DeleteIcon>
                <span>Delete Section</span>
              </button>
            </div>
          </div>
          {toggleCard && section && (
            <div className={"pt-6 "}>
              <div className="grid sm:grid-cols-4 md:grid-cols-8  xl:grid-cols-12 gap-6 text-sm">
                {/* Column A: keep original Subject/Title/Sub-Title widths */}
                <div className="col-span-4">
                  <div className="text-sm">
                    <label className="font-medium text-gray-700">Subject</label>
                  </div>
                  <div className="text-sm mt-1">
                    <input
                      className="block w-full border border-gray-300 text-gray-700 rounded-md shadow-sm py-2 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                      type="text"
                      value={section.subject}
                      onChange={(e) => onSectionSubjectChange(e)}
                    />
                  </div>

                  <div className="col-span-4">
                    <div className="text-sm mt-5">
                      <label className="font-medium text-gray-700">Title</label>
                    </div>
                    <div className={"text-sm mt-1"}>
                      <input
                        className="block w-full border border-gray-300 text-gray-700 rounded-md shadow-sm py-2 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                        type="text"
                        value={section.title}
                        multiple={true}
                        onChange={(e) => onSectionTitleChange(e)}
                      />
                    </div>
                  </div>
                  <div className="col-span-4">
                    <div className="text-sm mt-5">
                      <label className="font-medium text-gray-700">
                        Sub-Title
                      </label>
                    </div>
                    <div className={"text-sm mt-1"}>
                      <input
                        className="block w-full border border-gray-300 text-gray-700 rounded-md shadow-sm py-2 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                        type="text"
                        value={section.subtitle}
                        multiple={true}
                        onChange={(e) => onSectionSubTitleChange(e)}
                      />
                    </div>
                  </div>
                </div>

                {/* Column B: Calculator to the right, independent width */}
                {(props.cannedTestTypeId === 3 ||
                  props.cannedTestTypeId === 4) && (
                  <div className="col-span-4">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700">
                        Calculator
                      </label>
                    </div>
                    <div className="text-sm mt-1">
                      <Select
                        isClearable
                        value={
                          section.calculatorTypeId
                            ? calculatorOptions.find(
                                (o) => o.value === section.calculatorTypeId
                              )
                            : null
                        }
                        onChange={onSectionCalculatorChange}
                        options={calculatorOptions}
                        placeholder="None"
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {toggleCard &&
            sectionGroups &&
            sectionGroups.length > 0 &&
            sectionGroups.map((sectionGroup, groupIndex) => {
              return (
                <Fragment key={groupIndex}>
                  <SectionGroupCard
                    groupIndex={groupIndex}
                    editQuestionHandler={props.editQuestionHandler}
                    sectionGroup={sectionGroup}
                    onSectionGroupTypeChange={onSectionGroupTypeChange}
                    onSectionGroupInstructionChange={
                      onSectionGroupInstructionChange
                    }
                    handleDragEnd={handleDragEnd}
                    onQuestionChange={onQuestionChange}
                    onEditClick={onEditClick}
                    onDeleteGroupQuestionClick={onDeleteGroupQuestionClick}
                    onAddGroupQuestionClick={onAddGroupQuestionClick}
                    isEditIndex={isEditIndex}
                    setIsEditIndex={setIsEditIndex}
                    isEdit={isEdit}
                    setIsEdit={setIsEdit}
                    onDeleteGroupClick={onDeleteGroupClick}
                  ></SectionGroupCard>
                </Fragment>
              );
            })}
          {toggleCard && (
            <div className="flex justify-end w-full border-t mt-6">
              <button
                type="button"
                onClick={onAddGroupClick}
                className="flex my-4 mx-3  items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
              >
                <AddIcon className="w-3 h-3"></AddIcon>
                <span>Add Group</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(SectionCard);
